/**
 * Service: objectLock
 */
angular.module('acme.common.service.objectLock', [
  'acme.common.service.lockApi'
])
.service('ObjectLockService', ['LockApiService', function(LockApiService) {

    return {

      api: LockApiService,

      /*
      * items: [
      *         views: ['view1', 'view2'],
      *         ids: ['id1', 'id2']
      * ]
      */
      items: [],

      name: 'objectLock',
      key: 'lockAlwaysRequiredToUpdateRequiresLockObjects',

      init: function() {
        this.reset();
        return true;
      },

      reset: function() {
        this.items = [];
      },

      /*
      * props : {
      * views, id
      * }
      */
      add: function(props) {
        var found = this.findView(props.views),
            item = {};
        if (!found) {
          item = {
            views: props.views,
            ids: [props.id]
          };
          this.items.push(item);
        } else {
          if(!this.hasLock(found.view, props.id)) {
            item = this.items[found.index];
            item.ids.push(props.id);
          }
        }
      },

      /*
       * props : {
       * view, id
       * }
       */
      remove: function(props) {
        var found = this.findView([props.view]),
            foundId = this.hasLock(props.view, props.id),
            item,
            r = false;
        if (found && foundId) {

          r = this.items[found.index].ids.length;

          item = this.items[found.index];
          item.ids.splice(foundId.index, 1);

          if (item.ids.length <= 0) {
            this.items.splice(found.index, 1);
          }
        }

        return r;
      },

      //if to has object lock enabled.
      isEligible: function(state, params) {
        return (state.data && state.data.features && state.data.features.objectLock && state.data.features.objectLock.type);
      },

      hasLock: function(state, id) {
        var r = false,
            found,
            foundIdIndex,
            item;
        if (state && id) {
          found = this.findView([state]);
          item = this.items[found.index];
          if(item && (item.ids instanceof Array)) {
            foundIdIndex = item.ids.indexOf(id);
            if (foundIdIndex > -1 ) {
              r = {
                index: foundIdIndex
              };
            }
          }
        }
        return r;
      },

      //if to is not in items[x].views list and if from has a lock right now
      canRelease: function(sourceState, srcParams, destinationState, destParams) {
        var r = destinationState && destinationState.name;
        return (r && !this.findView([destinationState.name]) && this.hasLock(sourceState.name, srcParams.id));
      },

      /*
      * Is the stateName part of any current views
      */
      includesView: function(list, stateName) {
        var i, ii,
            re,
            r = false;
        list = list || [];
        for (i=0, ii=list.length; i < ii; i++) {
          re = new RegExp("^"+list[i]+".*");
          if (re.test(stateName)) {
            r = list[i];
            break;
          }
        }

        return r;
      },

      findView: function(stateNames) {
        var i, ii,
            j, jj,
            views,
            result,
            testState,
            r = false;
        for (i=0, ii=this.items.length; (i < ii) && !r; i++) {
          views = this.items[i].views;
          if (stateNames instanceof Array) {
            for (j=0, jj=stateNames.length; j < jj; j++) {
              testState = stateNames[i];
              result = this.includesView(views, testState);
              if (result) {
                r = {
                  index: i,
                  view: result
                };
                break;
              }
            }
          }
        }
        return r;
      }

    };

}]);
